import React from 'react';
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import logo from '../../assets/logo-2.png';
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-white">
            <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                <div className="flex flex-col md:flex-row md:justify-between gap-8">
                    {/* Logo */}
                    <div className="mb-6 md:mb-0 flex justify-center md:justify-start">
                        <Link to="/" className="flex items-center">
                            <img src={logo} className="h-32 md:h-40 me-3" alt="The Best Cab Logo" />
                        </Link>
                    </div>

                    {/* Contact Details */}
                    <div className='sm:mb-6'>
                        <h2 className="mb-4 text-sm font-semibold text-gray-900 uppercase">Contact Details</h2>
                        <ul className="text-gray-500 font-medium space-y-4">
                            <li className="flex items-start gap-2">
                                <Phone className="w-5 h-5 text-gray-500 mt-1" />
                                <p>
                                    <a href="tel:+917976710874" className="hover:text-pink-600">+91-7976710874</a>,
                                    <a href="tel:+919116710874" className="hover:text-pink-600">+91-9116710874</a>
                                </p>
                            </li>
                            <li className="flex items-start gap-2">
                                <Mail className="w-5 h-5 text-gray-500 mt-1" />
                                <a href="mailto:info@thebestcab.in" className="hover:text-pink-600">info@thebestcab.in</a>
                            </li>
                            <li className="flex items-start gap-2">
                                <MapPin className="w-5 h-5 text-gray-500 mt-1" />
                                <p className="hover:text-pink-600">Airport Terminal-2, Near Jawahar Circle, Jaipur</p>
                            </li>
                        </ul>
                    </div>

                    {/* Footer Links */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                        {/* Useful Links */}
                        <div>
                            <h2 className="mb-4 text-sm font-semibold text-gray-900 uppercase">Useful Links</h2>
                            <ul className="text-gray-500 font-medium space-y-2">
                                {["Jaipur", "Udaipur", "Agra", "Mumbai"].map((city, index) => (
                                    <li key={index}>
                                        <Link to="/packages" className="hover:text-pink-600">
                                            {city} Tour Package
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Follow Us */}
                        <div>
                            <h2 className="mb-4 text-sm font-semibold text-gray-900 uppercase">Follow us</h2>
                            <ul className="text-gray-500 font-medium space-y-2">
                                {["Instagram", "Facebook", "Twitter", "Youtube"].map((social, index) => (
                                    <li key={index}>
                                        <a href="/" className="hover:text-pink-600" aria-label={social}>{social}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Legal */}
                        <div>
                            <h2 className="mb-4 text-sm font-semibold text-gray-900 uppercase">Legal</h2>
                            <ul className="text-gray-500 font-medium space-y-2">
                                <li>
                                    <Link to="/privacy-policy" className="hover:text-pink-600">Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to="/terms-conditions" className="hover:text-pink-600">Terms & Conditions</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <hr className="my-6 border-gray-200" />

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between text-center gap-4">
                    <span className="text-sm text-gray-500">
                        © 2025 <Link to="/admin" className="hover:underline">The Best Cab™</Link>. All Rights Reserved.
                    </span>
                    <div className="flex justify-center gap-4">
                        {[{ icon: <FaInstagram />, label: "Instagram" },
                        { icon: <FaLinkedin />, label: "LinkedIn" },
                        { icon: <FaXTwitter />, label: "Twitter" },
                        { icon: <FaYoutube />, label: "Youtube" }]
                            .map((item, index) => (
                                <a key={index} href="/" className="text-gray-500 hover:text-gray-900" aria-label={item.label}>
                                    {item.icon}
                                </a>
                            ))}
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;